var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcUserWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2126_2887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9422 18.7069C21.4304 17.2828 23.1304 14.6311 23.1304 11.5646C23.1304 7.00956 19.4246 3.30371 14.8696 3.30371C10.3145 3.30371 6.60867 7.00956 6.60867 11.5646C6.60867 14.6311 8.30875 17.2828 10.7969 18.7069C4.57324 20.341 0 25.6031 0 31.8401V33.8689C0 34.3249 0.370113 34.695 0.826112 34.695C1.28211 34.695 1.65222 34.3249 1.65222 33.8689V31.8401C1.65215 25.2165 7.58185 19.8255 14.8696 19.8255C22.1573 19.8255 28.087 25.2165 28.087 31.8401V33.8689C28.087 34.3249 28.4571 34.695 28.9131 34.695C29.3691 34.695 29.7392 34.3249 29.7392 33.8689V31.8401C29.7391 25.6031 25.1659 20.3393 18.9422 18.7069ZM8.26089 11.5646C8.26089 7.91993 11.2249 4.95593 14.8696 4.95593C18.5142 4.95593 21.4782 7.91993 21.4782 11.5646C21.4782 15.2093 18.5142 18.1733 14.8696 18.1733C11.2249 18.1733 8.26089 15.2093 8.26089 11.5646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0669 18.7277C31.8578 17.5431 33.0442 15.5175 33.0442 13.2161C33.0442 9.57142 30.0802 6.60742 26.4355 6.60742C25.9795 6.60742 25.6094 6.97753 25.6094 7.43353C25.6094 7.88953 25.9795 8.25965 26.4355 8.25965C29.1682 8.25965 31.392 10.4835 31.392 13.2162C31.392 15.9488 29.1682 18.1727 26.4355 18.1727C25.9795 18.1727 25.6094 18.5428 25.6094 18.9988C25.6094 19.4548 25.9794 19.8247 26.4354 19.8247C31.9025 19.8247 36.3484 23.9337 36.3484 28.986V30.5638C36.3484 31.0198 36.7186 31.3899 37.1746 31.3899C37.6306 31.3899 38.0007 31.0198 38.0007 30.5638V28.986C38.0007 24.2113 34.6699 20.1552 30.0669 18.7277Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2126_2887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserWhite);
export default __webpack_public_path__ + "static/media/ic-user-white.ea89c6a02f659ea4965c21f86a608dea.svg";
export { ForwardRef as ReactComponent };